import React from 'react';

const Title = () => {
  return (
    <div className="title">
      {/*<h1>INSPIRE</h1>*/}
      <h2>INSPIRE</h2>
      <p>UPLOAD CREATIVE WORK TO INSPIRE OTHERS</p>
    </div>
  )
}

export default Title;